import { HISTORY_PATH } from './historyPath';
import i18n from '../../../locales/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import { faShip } from '@fortawesome/free-solid-svg-icons';

export const historyBar = {
  subheader: i18n.t('sidemenu.history.title'),
  items: [
    {
      title: i18n.t('sidemenu.history.order'),
      path: HISTORY_PATH.ORDER,
      icon: <FontAwesomeIcon icon={faBasketShopping} style={{ fontSize: '20px' }} />,
    },
    {
      title: i18n.t('sidemenu.history.delivery'),
      path: HISTORY_PATH.DELIVERY,
      icon: <FontAwesomeIcon icon={faCalendarDays} style={{ fontSize: '20px' }} />,
    },
    {
      title: i18n.t('sidemenu.history.shippingSchedule'),
      path: HISTORY_PATH.SHIPPING_SCHEDULE,
      icon: <FontAwesomeIcon icon={faShip} style={{ fontSize: '20px' }} />,
    },
  ],
};
